module.exports = __webpack_public_path__ + "img/Grow.c635c6ef.svg";